import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9544_189)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.6667 0.667969H3.33333C1.49533 0.667969 0 2.1633 0 4.0013V9.33464C0 11.1726 1.49533 12.668 3.33333 12.668H7.33333V14.0013H4.66667C4.298 14.0013 4 14.2993 4 14.668C4 15.0366 4.298 15.3346 4.66667 15.3346H11.3333C11.702 15.3346 12 15.0366 12 14.668C12 14.2993 11.702 14.0013 11.3333 14.0013H8.66667V12.668H12.6667C14.5047 12.668 16 11.1726 16 9.33464V4.0013C16 2.1633 14.5047 0.667969 12.6667 0.667969ZM3.33333 2.0013H12.6667C13.7693 2.0013 14.6667 2.89864 14.6667 4.0013V8.66797H1.33333V4.0013C1.33333 2.89864 2.23067 2.0013 3.33333 2.0013ZM12.6667 11.3346H3.33333C2.46533 11.3346 1.732 10.7753 1.456 10.0013H14.544C14.268 10.7753 13.5347 11.3346 12.6667 11.3346ZM9.2 8.0013H10.2C11.0467 8.0013 11.7333 7.31464 11.7333 6.46797V4.2013C11.7333 3.35464 11.0467 2.66797 10.2 2.66797H9.2C8.90533 2.66797 8.66667 2.90664 8.66667 3.2013V7.46797C8.66667 7.76264 8.90533 8.0013 9.2 8.0013ZM9.73333 3.7333H10.2C10.4573 3.7333 10.6667 3.94264 10.6667 4.19997V6.46797C10.6667 6.7253 10.4573 6.93464 10.2 6.93464H9.73333V3.7333ZM4.81067 8.0013C5.04067 8.0013 5.238 7.8373 5.28 7.6113L5.39067 7.01864H6.728L6.83267 7.6073C6.87333 7.8353 7.07133 8.0013 7.30267 8.0013H7.30933C7.61133 8.0013 7.838 7.72397 7.77667 7.42797L6.96267 3.4633C6.88267 3.01797 6.57 2.66864 6.06533 2.66864C5.56067 2.66864 5.21133 3.0593 5.142 3.44597L4.342 7.42997C4.28267 7.7253 4.50933 8.0013 4.81067 8.0013ZM6.052 3.80464L6.47733 6.0013H5.636L6.052 3.80464Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9544_189",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgAd;
